module.exports = __webpack_public_path__ + "img/Trash.5cef7636.svg";